// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3ax1u","inner":"Form_inner__1BwnR","range":"Form_range__2hcWe","name":"Form_name__l-wq0","actions":"Form_actions__38c5s"};